import React from "react";

const InfoCard: React.FC<{ title: string; subtitle?: string; children: React.ReactNode }> = ({title, subtitle, children}) => (
    <div className="mb-8">
        <h3 className="text-3xl lg:text-2xl font-semibold mb-2 text-neutral-900 dark:text-neutral-100">{title}</h3>
        {subtitle && <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-6">{subtitle}</p>}
        <div className="grid grid-cols-2 gap-px bg-neutral-100 dark:bg-neutral-800 rounded-2xl overflow-hidden border border-neutral-100 dark:border-neutral-800">
            {children}
        </div>
    </div>
);

export default InfoCard;
